import { Link } from "react-router-dom";
import { latestNews } from "@/mocks/homeData";

export default function LatestNewsSection() {
  return (
    <section id="news" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
            最新资讯
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 text-balance">
            漫画<span className="text-accent-500">资讯</span>速递
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            掌握51漫画平台最新动态，不错过每一部精彩作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {latestNews.slice(0, 1).map((news) => (
            <Link
              key={news.id}
              to={`/article/${news.title}`}
              className="lg:col-span-3 group block relative overflow-hidden rounded-2xl bg-foreground-950 min-h-[280px]"
            >
              <img
                src={news.image}
                alt={news.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 mb-3">
                  {news.category}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 leading-snug group-hover:text-accent-400 transition-colors duration-300">
                  {news.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-300 mt-2 line-clamp-2">
                  {news.excerpt}
                </p>
                <p className="text-xs text-foreground-400 mt-3">{news.date}</p>
              </div>
            </Link>
          ))}

          <div className="lg:col-span-2 grid grid-cols-1 gap-4 md:gap-5">
            {latestNews.slice(1, 3).map((news) => (
              <Link
                key={news.id}
                to={`/article/${news.title}`}
                className="group block bg-background-100 rounded-2xl p-5 md:p-6 hover:bg-background-200 transition-colors duration-300"
              >
                <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
                  {news.category}
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors duration-300">
                  {news.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-2 line-clamp-2">
                  {news.excerpt}
                </p>
                <p className="text-xs text-foreground-400 mt-3">{news.date}</p>
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {latestNews.slice(3, 5).map((news) => (
            <Link
              key={news.id}
              to={`/article/${news.title}`}
              className="group block bg-background-100 rounded-2xl p-5 md:p-6 hover:bg-background-200 transition-colors duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="flex-1">
                  <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
                    {news.category}
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-accent-500 transition-colors duration-300">
                    {news.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 mt-2 line-clamp-2">
                    {news.excerpt}
                  </p>
                  <p className="text-xs text-foreground-400 mt-3">{news.date}</p>
                </div>
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={news.image}
                    alt={news.title}
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}